import './init';
import App from '@/App';
// import ErrorFallback from '@/components/error-fall-back';
import store from '@/redux/store';
import '@/style.css';
// import * as Sentry from '@sentry/react';
import {createRoot} from 'react-dom/client';
// import {ErrorBoundary} from 'react-error-boundary';
import {Provider as ReduxProvider} from 'react-redux';

// // Global error handler
// const errorHandler = (error: Error, info: {componentStack: string}): void => {
//   // You can log errors to third-party services
//   if (import.meta.env.DEV) console.error(error, info);
// };

// if (import.meta.env.PROD) {
//   Sentry.init({
//     dsn: 'https://099f73584cab94310546bb851e8c082d@o316168.ingest.us.sentry.io/4507134915182592',
//     integrations: [
//       Sentry.browserTracingIntegration(),
//       Sentry.replayIntegration()
//     ],
//     // Performance Monitoring
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ['cors.node.np-platform.com'],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   });
// }
// Create app
const root = createRoot(document.getElementById('root')!);

// Render the app
root.render(
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>
);
